import { siteModel } from 'models/SiteModel';

export class loadArticleAsync {
    load(criterion = 'date') {
        const promise = new Promise((resolve, reject) => {
            $(document).ready(() => {
                const data = window.__articleModel__;
                window.__articleModel__ = null;
                resolve(data);
            });
        });

        return promise;
    }
};

export const repository = new loadArticleAsync();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/repositories/articleRepository.js